import { render } from "./TransferPage.vue?vue&type=template&id=73330b4d"
import script from "./TransferPage.vue?vue&type=script&lang=js"
export * from "./TransferPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__